export const CtrlTwrShipmentLegsMilestonesEntryDataElements = [
    // {
    //     dBKey: 'ProRef',
    //     displayName: 'PRO',
    //     primaryCol: false,
    //     mobileDisplay: true,
    //     sortable: false,
    //     colWidth: 150
    // },

    // {
    //     dBKey: 'ModeName',
    //     displayName: 'Mode',
    //     primaryCol: false,
    //     mobileDisplay: false,
    //     sortable: false,
    //     colWidth: 150
    // },
    {
        dBKey: 'MilestoneDT',
        displayName: 'Datetime',
        primaryCol: false,
        mobileDisplay: false,
        sortable: false,
        colWidth: 180
    },
    {
        dBKey: 'Milestone',
        displayName: 'Milestone',
        primaryCol: false,
        mobileDisplay: false,
        sortable: false,
        colWidth: 385
    },

    

]


export default CtrlTwrShipmentLegsMilestonesEntryDataElements

